import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 8l5 5 5-5z",
  fillRule: "evenodd"
});

var SvgCaretDownMinor = function SvgCaretDownMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCaretDownMinor as S };
